<template>
    <div class="main">
        <div class="home shadow">
            <breadcrumb></breadcrumb>
            <div style="padding: 10px 30px 20px 0px;">
                <el-row>
                    <el-col :span="6">
                        <div>
                            <sideNavigation></sideNavigation>
                        </div>
                    </el-col>
                    <el-col :span="18" style="margin-top: 20px">
                        <el-form :rules="rules3" ref="ruleForm" :model="form">
                            <div>
                                <el-row :gutter="20">
                                    <el-col :span="18">
                                        <el-form-item prop="certificateNo" label-width="150px" label="证件号码"
                                                      style="text-align: left">
                                            <el-input v-model="form.certificateNo"/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="18">
                                        <el-form-item prop="tel" label-width="150px" label="手机号码">
                                            <el-input v-model="form.tel"/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-button v-show="show" style="position: absolute;right: 26%;"
                                                   @click="getVerificationCode('ruleForm')">
                                            获取验证码
                                        </el-button>
                                        <span v-show="!show" style="position: absolute;right: 31%;margin-top: 6px;">剩余{{count}} s</span>
                                        <el-form-item label-width="150px" label="验证码" class="yanzhen">
                                            <el-input v-model="form.code" maxlength="6"
                                                      style="position: relative;width: 139%"/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <p class="certificateText"><span style="color: #F40000">*</span>注：证件号码包括身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、护照或者组织机构代码等
                                </p>
                            </div>
                            <div class="footer">
                                <el-button type="primary" @click="submit('ruleForm')">查询</el-button>
                            </div>
                        </el-form>
                    </el-col>
                </el-row>

            </div>
        </div>
    </div>
</template>

<script>
    import sideNavigation from "@/components/sideNavigation"
    import breadcrumb from "@/components/breadcrumb"

    export default {
        data() {
            var checkPhone = (rule, value, callback) => {
                const phoneReg = /^1[0-9][0-9]{9}$/
                if (!value) {
                    return callback(new Error('手机号码不能为空'))
                }
                setTimeout(() => {
                    if (!Number.isInteger(+value)) {
                        callback(new Error('请输入数字值'))
                    } else {
                        if (phoneReg.test(value)) {
                            callback()
                        } else {
                            callback(new Error('手机号码格式不正确'))
                        }
                    }
                }, 100)
            };

            return {
                show: true,
                count: '',
                timer: null,
                form: {
                    tel: '',
                    certificateNo: '',
                    code: '',
                    pageSize: 5
                },
                rules3: {
                    certificateNo: [
                        {required: true, message: '请输入证件号码', trigger: 'change'},
                    ],
                    tel: [
                        {required: true, message: '请输入联系电话', trigger: 'change'},
                        {validator: checkPhone, trigger: 'blur'}
                    ],
                }
            }
        },
        mounted() {
            // this.getIdSelect()
        },
        methods: {
            // 获取验证码
            getVerificationCode(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios({
                            url: '/application/getCode',
                            method: 'get',
                            headers: {tel: this.form.tel}
                        }).then(({data}) => {
                            this.$message({
                                showClose: true,
                                message: '验证码已成功发送到您的手机，请注意查收',
                                type: 'success'
                            });
                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                this.show = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.count--;
                                    } else {
                                        this.show = true;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000)
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 提交/先验 验证码
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios({
                            url: '/application/isValid',
                            method: 'get',
                            headers: {tel: this.form.tel, code: this.form.code}
                        }).then(({data}) => {
                            if (data.isValid == true) {
                                this.route_goFun3('表格展示')
                            }else {
                                this.$confirm('验证码错误', '提示', {
                                    cancelButtonText: '确定',
                                    showCancelButton:false,
                                    type: 'warning'})
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 查看申请表格
            route_goFun3(name) {
                sessionStorage.setItem('selectresult','2')
                this.$router.push({
                    path: '/select-result-table',
                    query: {
                        name: name,
                        id: 3,
                        tel: this.form.tel,
                        certificateNo: this.form.certificateNo,
                        pageSize: ' '
                    }
                })
            }

        },
        components: {
            sideNavigation,
            breadcrumb
        }
    }

</script>
<style>
    .progress {
        text-align: center;
        width: 60%;
        margin: 0 auto;
        padding: 20px 10px;
        margin-top: 100px;
    }

    .progress .tablestyle {
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .progress .anniu {

    }

    .progress .footer {
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .progress .yanzhen {
        margin-left: 50px;
    }
</style>
